<template>
  <article>
    <header>{{displayTitle}}</header>
  </article>
</template>

<script>
export default {
  name: "SearchResult",

  props: {
    item: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: "page"
    }
  },

  computed: {
    displayTitle() {
      switch (this.type) {
        case "form":
        case "policy":
          return this.item.current_version.title;
          break;
        case "external":
          return this.item.name;
          break;
        default:
          return this.item.title;
          break;
      }
    },
    displayText() {
      // TODO: Not entirely sure this will work at all, what do we display for policies/forms that have no content?
      if (this.item.elements) {
        const textBlocks = this.item.elements
          .filter(elem => elem.type === "text-block")
          .map(elem => elem.content);
        if (textBlocks.length >= 1) {
          return textBlocks[0];
        } else {
          return "";
        }
      }
      console.log(this.item);
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
header {
  color: $colour-cactus-core-green;;
}
main p {
  margin-top: 25px;
}
</style>
